/* The "new" values for the Validation tab: { validation_figure: [ ...rows ] }, one row per report, month and line item.
 * (What was reported comes from settlement_report_figure, through the reports API.) The app only reads this. Where it comes from (first that works):
 *   1. the server's /__srs_validation: the settlement_report_figure_latest table in PostgreSQL (or, with VALIDATION_STORE=json / in development, a JSON file)
 *   2. the sample bundled with the app (src/demo/db/srs-validation.seed.json)
 */
import seed from '../demo/db/srs-validation.seed.json';

const ENDPOINT = '/__srs_validation';
const valid = (doc) => !!doc && Array.isArray(doc.validation_figure);
let kind = 'sample';
let latestTable = 'settlement_report_figure_latest';

export async function loadValidation() {
  try {
    const res = await fetch(ENDPOINT);
    if (res && res.ok) {
      const type = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
      if (type.includes('json')) {                         // a static host answers unknown paths with index.html
        const doc = await res.json();
        if (valid(doc)) { kind = doc.source === 'database' ? 'database' : 'file'; return doc.validation_figure; }
      }
    }
  } catch { /* no server: use the sample */ }
  kind = 'sample';
  return seed.validation_figure;
}
export const validationLabel = () => (kind === 'database' ? `the ${latestTable} table` : kind === 'file' ? 'a JSON file on the server' : 'the sample data bundled with the app');
